export const AppliedCouponTag = {
  src: '/assets/images/icons/tags/coupon.svg',
  alt: 'tag-coupon',
  className: 'tag-coupon',
  label: 'Cupom aplicado',
};



// WEBPACK FOOTER //
// ./src/components/common/Tags/defaultTags.jsx